import { createContext, ReactNode, useEffect, useState } from "react";

export type PortalProviderContextProps = {
  root?: HTMLElement | React.MutableRefObject<HTMLElement | null> | null;
};

export const PortalProviderContext = createContext<PortalProviderContextProps>(
  {},
);

export type ProtalProviderProps = {
  root?: HTMLElement | React.MutableRefObject<HTMLElement | null> | null;
  children?: ReactNode;
};

export const PortalProvider = (props: ProtalProviderProps) => {
  const { root: rootProp, children } = props;
  const [root, setRoot] = useState(rootProp);

  useEffect(() => {
    setRoot(rootProp);
  }, [rootProp]);

  return (
    <PortalProviderContext.Provider value={{ root }}>
      {children}
    </PortalProviderContext.Provider>
  );
};
